import VendExp from '../../Model/VendExp';
import { validateBuilderExperience } from './validation';

export type BuilderDraftCompileResult = {
    experience?: VendExp;
    errors: string[];
    warnings: string[];
    parseError?: string;
};

export const parseBuilderDraft = (
    value: string,
    experience?: VendExp,
): BuilderDraftCompileResult => {
    try {
        const parsed = JSON.parse(value);
        const nextExperience = { ...(experience ?? {}), ...parsed } as VendExp;
        const validation = validateBuilderExperience(nextExperience);

        return {
            experience:
                validation.errors.length === 0 ? nextExperience : undefined,
            errors: validation.errors,
            warnings: validation.warnings,
        };
    } catch (error) {
        return {
            errors: [],
            warnings: [],
            parseError: 'Invalid JSON. Fix the code view before compiling.',
        };
    }
};
